import React, {Component} from "react";

class ThemeSelector extends Component {
	state = {
		theme : 'default'
	};

	componentWillMount() {
		const theme = localStorage.getItem("theme");
		this.setState({theme : theme ? theme : 'default'});
	}

	handleThemeChange(e) {
		const theme = this.state.theme === 'default' ? 'dark' : 'default';
		localStorage.setItem('theme', theme);
		document.location.reload();
	}

	render() {
		return (
			<div className={`topmenu__service-theme ${this.state.theme === 'dark' && 'activated'}`} onClick={this.handleThemeChange.bind(this)}></div>
		);
	}
}

export default ThemeSelector;


// WEBPACK FOOTER //
// ./src/app/components/ThemeSelector.js